import { Controller } from "@hotwired/stimulus"

/**
 * Observability Filters Controller
 *
 * Handles filter form submission for the observability index page.
 * Select/date changes submit immediately; text search is debounced.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["form", "search"]

  declare readonly formTarget: HTMLFormElement
  declare readonly searchTarget: HTMLInputElement

  private debounceTimer: ReturnType<typeof setTimeout> | null = null

  filter() {
    this.formTarget.requestSubmit()
  }

  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, 300)
  }
}
